<template>
  <div>
    <MdButton class="md-raised" @click="$emit('clear')">
      Clear
    </MdButton>

    <MdTable>
      <MdTableRow>
        <MdTableHead>Key</MdTableHead>
        <MdTableHead>User ID</MdTableHead>
        <MdTableHead>Timestamp</MdTableHead>
        <MdTableHead>Event</MdTableHead>
        <MdTableHead>Args</MdTableHead>
      </MdTableRow>
      <MdTableRow v-for="c in commands" :key="c.id">
        <MdTableCell>{{ c.key }}</MdTableCell>
        <MdTableCell>{{ c.uid }}</MdTableCell>
        <MdTableCell>{{ c.timestamp }}</MdTableCell>
        <MdTableCell>{{ c.event }}</MdTableCell>
        <MdTableCell>{{ c.args }}</MdTableCell>
      </MdTableRow>
    </MdTable>
  </div>
</template>

<script>
export default {
  props: {
    commands: { type: Array, default: () => ([]) },
  },
};
</script>
